import { Box, Chip } from "@mui/material";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { handleError } from "../../../../utils/handleError";
import CardRunningClub from "./CardRunningClub";
import Loading from "../../../../components/Loading/Loading";
import { getAllRunningsClubsAPI } from "../../../../services/rest/runningsClubs/runningClubUser";
import { useDispatch, useSelector } from "react-redux";
import {
  setAllRunningsClubs,
  setRunningsClubsOfUser,
} from "../../../../redux/slice/runningsClubsSlice";
import {
  filterRunningClubDontUser,
  filterRunningClubOfuser,
} from "./filterRunningClubs";

const RunningsClubs = () => {
  const { allRunningsClubs, runningsClubsOfUser } = useSelector(
    (state) => state.runningsClubsReducer
  );
  const { _id } = useSelector((state) => state.userReducer);
  const [loading, setLoading] = useState(true);
  const [selectedChip, settSelectedChip] = useState("runningsClubs");
  const dispatch = useDispatch();

  //Obtenemos runningsClubs de usuario y que no esta unido
  const getAllRunningsClubs = async () => {
    try {
      //hacemos la petición de todas los clubs de corredores
      const listResponse = await getAllRunningsClubsAPI();
      const runningsClubsOfUser = filterRunningClubOfuser(listResponse, _id);
      const AllRunnningClubs = filterRunningClubDontUser(listResponse, _id);
      dispatch(
        setAllRunningsClubs({ allRunningsClubs: AllRunnningClubs ?? [] })
      );
      dispatch(
        setRunningsClubsOfUser({ runningsClubsOfUser: runningsClubsOfUser })
      );
      // console.log("Clubs de usuario", runningsClubsOfUser);

      setLoading(false);
    } catch (error) {
      const { message } = handleError(error);
      setLoading(false);
      toast.error(
        `En este momento no se pueden obtener los clubs de corredores. \n ${message}`
      );
    }
  };
  useEffect(() => {
    getAllRunningsClubs();
  }, []);
  // console.log("RunningsClubs todos", allRunningsClubs);

  return (
    <Box
      sx={{
        paddingLeft: 4,
        paddingRight: 4,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 4,
      }}
    >
      <Loading loading={loading} />
      <Box sx={{ display: "flex", gap: 5 }}>
        <Chip
          label="Clubs"
          style={
            selectedChip === "runningsClubs"
              ? {
                  backgroundColor: "#e7ef7d",
                  color: "black",
                }
              : {}
          }
          onClick={() => settSelectedChip("runningsClubs")}
        />
        <Chip
          label="Mis clubs"
          variant={"filled"}
          style={
            selectedChip === "runningsClubsOfUser"
              ? {
                  backgroundColor: "#e7ef7d",
                  color: "black",
                }
              : {}
          }
          onClick={() => settSelectedChip("runningsClubsOfUser")}
        />
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyItems: "center",
          flexWrap: "wrap",
          gap: 5,
          justifyContent: { xs: "center", sm: "flex-center" },
        }}
      >
        {selectedChip === "runningsClubs" &&
          allRunningsClubs &&
          allRunningsClubs.map((runningClub) => (
            <Box
              key={runningClub?._id}
              sx={{
                width: { xs: "100%", sm: "48%", md: "30%", lg: "23%" },
                minWidth: { xs: "100%", sm: 300 },
              }}
            >
              <CardRunningClub
                runningClub={runningClub}
                type={"general"}
                setLoading={setLoading}
              />
            </Box>
          ))}
        {selectedChip === "runningsClubsOfUser" &&
          runningsClubsOfUser &&
          runningsClubsOfUser.map((runningClub) => (
            <Box
              key={runningClub?._id}
              sx={{
                width: { xs: "100%", sm: "48%", md: "30%", lg: "23%" },
                minWidth: { xs: "100%", sm: 300 },
              }}
            >
              <CardRunningClub
                runningClub={runningClub}
                type={"ofUser"}
                setLoading={setLoading}
              />
            </Box>
          ))}
      </Box>
    </Box>
  );
};

export default RunningsClubs;
